//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpControlGroup from '../layout/ControlGroup.vue';

export default {
  name: 'DpBreadcrumbs',
  components: { DpControlGroup },
  props: {
    breadcrumbs: { type: Array, default: () => [], required: true },
  },
  methods: {
    navigateToPrevious() {
      const previousBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 2];
      if (!previousBreadcrumb) return;
      this.$router.push(previousBreadcrumb.route);
    },
  },
};
